
import Vue from 'vue'
import VFacebookLogin from 'vue-facebook-login-component'

export default Vue.extend({
  name: 'SocialLogin',
  components: {
    VFacebookLogin,
  },
  computed: {
    googleClientId: function (): string {
      return process.env.VUE_APP_GOOGLE_LOGIN_CLIENT_ID ?? ''
    },
    fbAppId: function (): string {
      return process.env.VUE_APP_FB_LOGIN_APP_ID ?? ''
    },
  },
  data: () => ({
    FB: {} as any,
    scope: {} as any,
  }),
  mounted() {
    this.initGoogleSignIn()
  },
  methods: {
    initGoogleSignIn() {
      const checkGsi = setInterval(() => {
        if (typeof (window as any).google !== 'undefined') {
          clearInterval(checkGsi);

          const google = (window as any).google;

          google.accounts.id.initialize({
            // eslint-disable-next-line @typescript-eslint/camelcase
            client_id: this.googleClientId,
            callback: this.handleGoogleResponse,
          });

          google.accounts.id.renderButton(
              this.$refs.googleBtn as HTMLElement,
              {
                theme: 'outline',
                size: 'large',
                width: 140,
                height: 50,
                text: 'signin',
                shape: 'rectangular'
              }
          );
        }
      }, 200);
    },

    handleGoogleResponse(response: any) {
      const idToken = response.credential;
      const base64Url = idToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

      const jsonPayload = decodeURIComponent(
          window.atob(base64)
              .split('')
              .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
              .join('')
      );

      const user = JSON.parse(jsonPayload);

      this.$store.dispatch('authentication/signInSocial', {
        url: '/login-g',
        api: this.$api,
        token: idToken,
        email: user.email,
        firstname: user.given_name,
        lastname: user.family_name
      });
    },
    fbLoggedIn(response: any) {
      if (!response || !response.authResponse) {
        return
      }

      this.FB.api(
        '/me',
        { fields: 'email, first_name, last_name' },
        (meResponse: any) => {
          this.$store
            .dispatch('authentication/signInSocial', {
              url: '/login-fb',
              token: response.authResponse.accessToken,
              api: this.$api,
              email: meResponse.email,
              firstname: meResponse.first_name,
              lastname: meResponse.last_name,
            })
            .then(() => this.FB.logout())
        }
      )
    },
    fbSdkInit({ FB, scope }: any) {
      this.FB = FB
      this.scope = scope
    },
  },
})
